module.exports = __webpack_public_path__ + "static/img/vulva-repair.be305c4c.png";